export enum StatusCodes {
  InternalServerError = 500,
  BadRequest = 400,
  Unauthorized = 401,
  NotFound = 404,
  Forbidden = 403,
}
